var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M52.29,65h0A3.32,3.32,0,0,0,50,66l-3.64,3.65v-21a3.31,3.31,0,1,0-6.61,0v21L36.05,66a3.31,3.31,0,0,0-4.67,4.68L40.66,80a3.4,3.4,0,0,0,1.08.72,3.22,3.22,0,0,0,1.26.25,3.36,3.36,0,0,0,2.34-1l9.28-9.28A3.31,3.31,0,0,0,52.29,65Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M70,24.74q.06-.79.06-1.56a23.17,23.17,0,0,0-45.18-7.27,23.18,23.18,0,0,0,.87,46.34h5.08a3.31,3.31,0,0,0,0-6.61H25.73a16.57,16.57,0,1,1,0-33.13c.4,0,.8,0,1.2.06h.18a3.22,3.22,0,0,0,3.53-2.66,16.56,16.56,0,0,1,32.8,3.26,17.31,17.31,0,0,1-.36,3.46,3.33,3.33,0,0,0,.54,2.6,3.3,3.3,0,0,0,2.28,1.35,12.58,12.58,0,0,1-1.65,25.05H55.19a3.31,3.31,0,1,0,0,6.61h9.06A19.19,19.19,0,0,0,70,24.74Z","fill":"#2a2d58","key":2})]);
}

Download.defaultProps = {"viewBox":"0 0 86 80.93"};

module.exports = Download;

Download.default = Download;
